import { Trophy } from "lucide-react";

import { Card } from "@/components/ui/card";

/**
 * The "you did it all" banner atop a campaign's main column — the missions ladder once every
 * mission is done, a chase once every rung is won. One surface for every type (a gold trophy,
 * the title in the prize colour, a quiet subtitle); each type passes its own two lines.
 */
export const CampaignCompletedBanner = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => (
  <Card className="flex items-center gap-3.5">
    <Trophy className="size-6 shrink-0 text-prizes" strokeWidth={1.75} />
    <div className="flex min-w-0 flex-col gap-0.5">
      <p className="font-heading text-[14px] leading-[18px] font-bold text-prizes lg:text-[16px] lg:leading-5">
        {title}
      </p>
      <p className="font-body text-[12px] leading-4 text-foreground-secondary">
        {subtitle}
      </p>
    </div>
  </Card>
);
